




























































import { Component, Vue } from "vue-property-decorator";
import FeeScheduleAndRatesDeepLink from "@/employee/components/landing-pages/hsabank/FeeScheduleAndRatesDeepLink.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { HsabAccountNametag, HsabSsoDestination } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useInterestRateStore } from "@/employer/store/interestRate";
import { useEmployerFeeScheduleStore } from "@/employer/store/employerFeeSchedule";

@Component({
  components: { GenericLoadingSpinner, SsoDeepLink, FeeScheduleAndRatesDeepLink }
})
export default class FeeScheduleAndInterestRates extends Vue {
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  interestRateStore = useInterestRateStore();
  employerFeeScheduleStore = useEmployerFeeScheduleStore();

  isModalOpen = false;

  get showFeeScheduleAndRates (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount
        && this.featureFlagStore.featureFlagsAvailable
        && (this.featureFlagStore.flags.bend21840ShowFeeScheduleAndRatesDeepLink
            || this.featureFlagStore.flags.bend25422ShowFeeScheduleAndRatesModal);
  }

  get showDeepLinkButton (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount
        && this.featureFlagStore.featureFlagsAvailable
        && this.featureFlagStore.flags.bend21840ShowFeeScheduleAndRatesDeepLink;
  }

  get showOpenModalButton (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount
        && this.featureFlagStore.featureFlagsAvailable
        && this.featureFlagStore.flags.bend25422ShowFeeScheduleAndRatesModal;
  }

  get hsabFeeScheduleAndRatesDeepLinkLocation () {
    return HsabSsoDestination.FeeScheduleAndRates;
  }

  get isLoadingModalData () {
    return this.interestRateStore.isLoading
        || this.employerFeeScheduleStore.isLoading;
  }

  get interestRateTableFields () {
    return [
      { key: "balance", label: "Balance", thClass: "col-7 col-md-5", tdClass: "col-7 col-md-5" },
      { key: "interestRate", label: "Interest Rate" }
    ];
  }

  get interestRates () {
    if (this.interestRateStore.interestRates === undefined
        || this.interestRateStore.interestRates === null
        || this.interestRateStore.interestRates.length === 0) {
      return [];
    }
    return this.interestRateStore.getInterestRatesAsTableData;
  }

  get feeScheduleTableFields () {
    return [
      { key: "feeType", label: "Fee", thClass: "col-7 col-md-5", tdClass: "col-7 col-md-5" },
      { key: "amount", label: "Amount", thClass: "col-3 col-md-2", tdClass: "col-3 col-md-2" },
      { key: "waiver", label: "" }
    ];
  }

  get feeSchedules () {
    if (this.employerFeeScheduleStore.employerFeeSchedules === undefined
        || this.employerFeeScheduleStore.employerFeeSchedules === null
        || this.employerFeeScheduleStore.employerFeeSchedules.length === 0) {
      return [];
    }
    return this.employerFeeScheduleStore.getFeeScheduleTableItemsForAccountholder;

  }

  onShowModalClicked () {
    if (this.interestRateStore.isUninitialized) {
      this.interestRateStore.loadInterestRates();
    }
    if (this.employerFeeScheduleStore.isUninitialized) {
      let offeringId = 0;

      if (this.hsabAccountsStore.hsaAccounts) {
        const hsaAccount = this.hsabAccountsStore.hsaAccounts.find(x => x.isActive);
        offeringId = hsaAccount.offeringId;
      }
      const args = { username: null, partnerId: null, offeringId };
      this.employerFeeScheduleStore.loadEmployerFeeSchedules(args);
    }

    this.isModalOpen = true;
  }

  onModalCloseClicked () {
    this.isModalOpen = false;
  }
}
